module.exports = __webpack_public_path__ + "img/spellbound.e9a1aa83.jpg";